import {
  Grid,
  Section,
  Card,
  CardContent,
  CardHeader,
} from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import {
  loadDummyPlatforms,
  loadCostModelCurrencies,
} from 'scenes/Campaigns/sources/fields';

import {
  Campaign,
  AutoNameSwitch,
} from 'scenes/Campaigns/components/Form/Campaign';
import { GENERATE_NAME_AUTOMATICALLY } from 'scenes/Campaigns/components/Form/Campaign/constants';
import {
  LabelsField,
  OwnerField,
  AffiliateField,
  ApplicationField,
  SimpleNetworkField,
  SimplePlatformField,
  CountryField,
  TypeField,
} from 'scenes/Campaigns/components/Form/fields';
import { GeneralSection } from 'scenes/Campaigns/components/Form/sections/GeneralSection';
import { TargetingSection } from 'scenes/Campaigns/components/Form/sections/TargetingSection';
import {
  RATE_CURRENCY,
  RATE_VALUE,
  RATE_PERIOD,
} from 'scenes/Campaigns/components/Form/constants';
import { dummyCampaignSchema } from './schema';

const DummyCampaignForm = withForm({
  enableReinitialize: true,
  validationSchema: dummyCampaignSchema,
})(({ title, onClose, onExited, loading, open, values, children }) => {
  const { [GENERATE_NAME_AUTOMATICALLY]: generateNameAutomatically } = values;

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title title={title} />
      <SidePageV2.NewBody>
        <TargetingSection
          application={<ApplicationField />}
          network={<SimpleNetworkField />}
          affiliate={<AffiliateField />}
          platform={
            <SimplePlatformField
              withDeselectButton={false}
              source={loadDummyPlatforms}
            />
          }
          country={<CountryField />}
        />

        <GeneralSection
          campaign={
            <Campaign generateNameAutomatically={generateNameAutomatically} />
          }
          autoNameSwitch={<AutoNameSwitch />}
          label={<LabelsField />}
          owner={<OwnerField />}
          type={<TypeField />}
        />

        <Section title={'Cost Models'} required={true}>
          <Card elevation={6}>
            <CardHeader title={'Custom Flat Fee (UA)'} />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item container xs={3} spacing={3}>
                  <Grid item xs={6}>
                    <FormField.TextField
                      name={RATE_VALUE}
                      required={true}
                      label={'Rate'}
                      type={'number'}
                      padding={0}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormField.Select
                      name={RATE_CURRENCY}
                      required={true}
                      source={loadCostModelCurrencies}
                      label={'Currency'}
                      padding={0}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  <FormField.DateRangePicker
                    basis={'33.3%'}
                    label={'Period'}
                    name={RATE_PERIOD}
                    placeholder={'Select period'}
                    presets={[]}
                    padding={0}
                    required={true}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Section>
        {children}
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default DummyCampaignForm;
